import { render, staticRenderFns } from "./more-video-line.vue?vue&type=template&id=a50a6968&scoped=true"
import script from "./more-video-line.vue?vue&type=script&lang=js"
export * from "./more-video-line.vue?vue&type=script&lang=js"
import style0 from "./more-video-line.vue?vue&type=style&index=0&id=a50a6968&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a50a6968",
  null
  
)

export default component.exports